import { useId } from 'react';

/** «?» у названия стола: текст всегда в разметке, виден по наведению и фокусу. */
export function TrayWhy(): React.ReactElement {
  const tip = useId();
  return (
    <span className="nx-tray__ask">
      <button type="button" className="nx-tray__q" aria-label="как пользоваться калькулятором" aria-describedby={tip}>
        ?
      </button>
      <span id={tip} className="nx-tray__tip" role="tooltip">
        вбил сумму на одно плечо — второе само. галочка «живой» — кэф этой ноги
        с ленты, с ячейки — если сверка узнала ту же ставку; снял — застыл,
        пишешь сам. обратно — эта нога, не сосед и не рождение
      </span>
    </span>
  );
}

export function TrashMark(): React.ReactElement {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d="M3.5 4.5h9" />
      <path d="M6.2 4.5V3.2h3.6v1.3" />
      <path d="M5 6v6.5M8 6v6.5M11 6v6.5" />
      <path d="M4.6 4.5 5.2 13h5.6l.6-8.5" />
    </svg>
  );
}

export function ShutMark(): React.ReactElement {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
      <path d="M4.5 4.5 11.5 11.5M11.5 4.5 4.5 11.5" />
    </svg>
  );
}
